<template>
  <div class="footer">
    <div class="footerAll">
      <p class="footMusicWOW">
        2017MusicWOW音乐窝 Inc.All rights reseved. 广州市乐沃信息科技有限公司
        版权所有 <a href="http://beian.miit.gov.cn">粤ICP备18022034号</a>
      </p>
      <p class="footMusicWOW">提示：投资有风险 加盟需谨慎</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "footers",
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
<style lang="sass" scoped>
.footerAll
  background: rgba(249,249,249,1)
  font-size: 10px
  text-align: left
  padding: 30px 0
  font-size: 0.266667rem
  text-align: left
  padding: 20px 10px 20px 10px
  .footTel
    font-size: 28px
    margin-top: 13px
  .footDay
    color: #9E9E9E
    font-size: 10px
  .footBut
    width: 204px
    height: 41px
    background: rgba(7,209,170,1)
    border-radius: 21px
    color: #fff
    font-size: 18px
    border: none
    margin-top: 18px
  img
    width: 139px !important
    height: 37px
  .footMusicWOW
    font-size: 10px
    color: #9E9E9E
</style>

